import '@isceco/widget-library2/basic-elements/Popup/Popup'
import NumberUtil from "../../services/NumberUtil";

export default class EnergyCell {

  render(_, cell) {
    const value = Number(cell)
    if (isNaN(value)) {
      return cell
    }
    return NumberUtil.format(value) + ' kWh'
  }
}
